var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93928 6.99994L0.999943 2.0606C0.70705 1.76771 0.70705 1.29284 0.999943 0.999943C1.29284 0.70705 1.76771 0.70705 2.0606 0.999943L6.99994 5.93928L11.9393 0.999943C12.2322 0.70705 12.7071 0.70705 12.9999 0.999943C13.2928 1.29284 13.2928 1.76771 12.9999 2.0606L8.0606 6.99994L12.9999 11.9393C13.2928 12.2322 13.2928 12.7071 12.9999 12.9999C12.7071 13.2928 12.2322 13.2928 11.9393 12.9999L6.99994 8.0606L2.0606 12.9999C1.76771 13.2928 1.29284 13.2928 0.999943 12.9999C0.70705 12.7071 0.70705 12.2322 0.999943 11.9393L5.93928 6.99994Z",
    fill: "#000624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.07a6f76c1dbb72772f3cbdcd649c0ced.svg";
export { ForwardRef as ReactComponent };